const prefectureData = [
  { slug: 'Hokkaido', name: '北海道', area: 'hokkaido-tohoku' },
  { slug: 'Aomori', name: '青森県', area: 'hokkaido-tohoku' },
  { slug: 'Iwate', name: '岩手県', area: 'hokkaido-tohoku' },
  { slug: 'Miyagi', name: '宮城県', area: 'hokkaido-tohoku' },
  { slug: 'Akita', name: '秋田県', area: 'hokkaido-tohoku' },
  { slug: 'Yamagata', name: '山形県', area: 'hokkaido-tohoku' },
  { slug: 'Fukushima', name: '福島県', area: 'hokkaido-tohoku' },
  { slug: 'Ibaraki', name: '茨城県', area: 'kanto' },
  { slug: 'Tochigi', name: '栃木県', area: 'kanto' },
  { slug: 'Gunma', name: '群馬県', area: 'kanto' },
  { slug: 'Saitama', name: '埼玉県', area: 'kanto' },
  { slug: 'Chiba', name: '千葉県', area: 'kanto' },
  { slug: 'Tokyo', name: '東京都', area: 'kanto' },
  { slug: 'Kanagawa', name: '神奈川県', area: 'kanto' },
  { slug: 'Niigata', name: '新潟県', area: 'chubu' },
  { slug: 'Toyama', name: '富山県', area: 'chubu' },
  { slug: 'Ishikawa', name: '石川県', area: 'chubu' },
  { slug: 'Fukui', name: '福井県', area: 'chubu' },
  { slug: 'Yamanashi', name: '山梨県', area: 'chubu' },
  { slug: 'Nagano', name: '長野県', area: 'chubu' },
  { slug: 'Gifu', name: '岐阜県', area: 'chubu' },
  { slug: 'Shizuoka', name: '静岡県', area: 'chubu' },
  { slug: 'Aichi', name: '愛知県', area: 'chubu' },
  { slug: 'Mie', name: '三重県', area: 'kinki' },
  { slug: 'Shiga', name: '滋賀県', area: 'kinki' },
  { slug: 'Kyoto', name: '京都府', area: 'kinki' },
  { slug: 'Osaka', name: '大阪府', area: 'kinki' },
  { slug: 'Hyogo', name: '兵庫県', area: 'kinki' },
  { slug: 'Nara', name: '奈良県', area: 'kinki' },
  { slug: 'Wakayama', name: '和歌山県', area: 'kinki' },
  { slug: 'Tottori', name: '鳥取県', area: 'chugoku-shikoku' },
  { slug: 'Shimane', name: '島根県', area: 'chugoku-shikoku' },
  { slug: 'Okayama', name: '岡山県', area: 'chugoku-shikoku' },
  { slug: 'Hiroshima', name: '広島県', area: 'chugoku-shikoku' },
  { slug: 'Yamaguchi', name: '山口県', area: 'chugoku-shikoku' },
  { slug: 'Tokushima', name: '徳島県', area: 'chugoku-shikoku' },
  { slug: 'Kagawa', name: '香川県', area: 'chugoku-shikoku' },
  { slug: 'Ehime', name: '愛媛県', area: 'chugoku-shikoku' },
  { slug: 'Kochi', name: '高知県', area: 'chugoku-shikoku' },
  { slug: 'Fukuoka', name: '福岡県', area: 'kyushu' },
  { slug: 'Saga', name: '佐賀県', area: 'kyushu' },
  { slug: 'Nagasaki', name: '長崎県', area: 'kyushu' },
  { slug: 'Kumamoto', name: '熊本県', area: 'kyushu' },
  { slug: 'Oita', name: '大分県', area: 'kyushu' },
  { slug: 'Miyazaki', name: '宮崎県', area: 'kyushu' },
  { slug: 'Kagoshima', name: '鹿児島県', area: 'kyushu' },
  { slug: 'Okinawa', name: '沖縄県', area: 'kyushu' },
] as const satisfies {
  slug: string;
  name: string;
  area: string;
}[];

export const prefectures = prefectureData.map(({ slug, name }) => {
  return { slug, name };
});

const areaData = [
  { slug: 'hokkaido-tohoku', name: '北海道・東北' },
  { slug: 'kanto', name: '関東' },
  { slug: 'chubu', name: '中部' },
  { slug: 'kinki', name: '近畿' },
  { slug: 'chugoku-shikoku', name: '中国・四国' },
  { slug: 'kyushu', name: '九州・沖縄' },
] as const satisfies {
  slug: string;
  name: string;
}[];

export const areas = areaData.map((area) => {
  return {
    slug: area.slug,
    name: area.name,
    prefectures: prefectureData.filter((prefecture) => prefecture.area === area.slug),
  };
});

export const areaSlugToName = (slug: string) => {
  const area = areas.find((a) => a.slug === slug);
  return area ? area.name : '';
};

export const areaNameToSlug = (name: string) => {
  const area = areas.find((a) => a.name === name);
  return area ? area.slug : '';
};

export const prefectureSlugToName = (slug: string) => {
  const prefecture = prefectures.find((p) => p.slug === slug);
  return prefecture ? prefecture.name : '';
};

export const prefectureNameToSlug = (name: string) => {
  const prefecture = prefectures.find((p) => p.name === name);
  return prefecture ? prefecture.slug : '';
};
